module.exports = __webpack_public_path__ + "static/media/CB-CBI.135f69fa.pdf";